<template>
  <div>
    <el-dialog
        title="绑定手机"
        :visible.sync="showDialog"
        :width=dialogWidth
        :before-close="closeDialog"
        center>
      <div>
        <el-form :model="bindPhoneForm" label-width="70px" class="demo-ruleForm" size="mini" :rules="bindPhoneRule" ref="bindPhoneForm">
          <el-form-item label="手机号码" prop="phone">
            <el-input v-model="bindPhoneForm.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item >
            <el-button size="mini" type="warning" @click="sendCode('phone')" class="code_btn">{{ code_txt }}</el-button>
          </el-form-item>
          <el-form-item label="验证码"  prop="code">
            <el-input v-model="bindPhoneForm.code" class="code_input" placeholder="验证码"></el-input>
          </el-form-item>
          <el-button size="mini" type="warning" @click="handleBind('bindPhoneForm')" class="bind_btn">绑定</el-button>
          <div class="placehold"></div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ScreenMixins from '@/mixins/ScreenMixins';
import {txPostRequest} from "@/plugins/request";
export default {
  name: 'BindPhone',
  props: ['show'],
  mixins: [ScreenMixins],
  data() {
    const validatePhone = (rule, value, callback) => {
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (value === '') {
        callback(new Error('请输入手机号'));
      } else if (!phoneRegex.test(value)) {
        callback(new Error('无效的手机号码'));
      } else {
        callback();
      }
    };
    const validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入验证码'));
      }else {
        callback();
      }
    };
    return {
      Interval:'',
      countDown:10,
      code_txt:'获取验证码',
      dialogWidth:"50%",
      bindPhoneForm:{
        phone:'',
        code:'',
      },
      bindPhoneRule: {
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        code: [
          { validator: validateCode, trigger: 'blur' }
        ]
      },
    };
  },
  computed: {
    showDialog() {
      return this.handleDialog()
    }
  },
  methods: {
    sendCode(field){
      if (this.Interval){
        return
      }
      let i=0;
      this.code_txt=(--this.countDown)+"秒再获取"
      // 一顿操作
      this.Interval=setInterval(()=>{
        this.countDown--
        this.code_txt=this.countDown+"秒再获取"
        if (!i){
          this.request_code()
        }
        i++
        if (this.countDown===0){
          clearInterval(this.Interval)
          this.countDown=10
          this.code_txt='发送验证码'
          this.Interval=''
        }
      },1000)
      this.$refs.realNameForm.validateField(field, (errorMessage) => {
        if (errorMessage){
          clearInterval(this.Interval)
          this.Interval=''
          this.countDown=10
          this.code_txt='发送验证码'
        }
      });
    },
   async request_code(){
      await txPostRequest('/sms/verification_code',{ phone: this.bindPhoneForm.phone},{
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      })
    },
    handleBind(formName){
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          await txPostRequest('/sms/bind_phone',{phone: this.bindPhoneForm.phone, sms_code :  this.bindPhoneForm.code})
          this.successMessage()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    closeDialog(){
      this.$emit('child-phone', false);
      this.bindPhoneForm={
        phone:'',
        code:'',
      }
    },
    handleDialog() {
      this.updateDialogWidth();
      window.addEventListener('resize', this.updateDialogWidth);
      return !!this.show
    },
  },

  mounted() {
  }
};
</script>

<style scoped>
.bind_btn{
  position: absolute;
  left: 42%;
  margin-bottom: 24px;
}
.placehold{
  margin: 150px 0;
}
.el-dialog__wrapper>>>.el-dialog__body{
  display: flex;
  justify-content: center;
}
</style>
